/* eslint-disable react/no-unescaped-entities */
import React from "react";
import LeftNav from "./leftSideNav/LeftNav";
import TopBar from "./topBar/TopBar";

import pageMaintenance from "../images/maintenance.svg";

const PageMaintenance = () => {
  return (
    <div className="wrapper">
      <LeftNav />
      <div className="content-page">
        <TopBar title="Maintenance" />
        <div className="content">
          <div className="container-fluid">
            <div className="mt-5 mb-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12">
                    <div className="text-center">
                      <img
                        src={pageMaintenance}
                        height="140"
                        alt="File not found Image"
                      />
                      <h3 className="mt-4">
                        Page is Under Maintenance
                      </h3>
                      <p className="text-muted">
                        We're making the system more awesome. We'll be
                        back shortly.
                      </p>

                      <div className="row mt-5">
                        <div className="col-md-4">
                          <div className="text-center mt-3 pl-1 pr-1">
                            <i className="dripicons-jewel bg-primary maintenance-icon text-white mb-2"></i>
                            <h5 className="text-uppercase">
                              Why is the Page Down?
                            </h5>
                            <p className="text-muted">
                              We are serving the angels. We will be
                              back to serve humans shortly
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="text-center mt-3 pl-1 pr-1">
                            <i className="dripicons-clock bg-primary maintenance-icon text-white mb-2"></i>
                            <h5 className="text-uppercase">
                              What is the Downtime?
                            </h5>
                            <p className="text-muted">
                              Shhh.. We are Sleeping and dreaming
                              about new features to implement. Will be
                              back soon
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="text-center mt-3 pl-1 pr-1">
                            <i className="dripicons-question bg-primary maintenance-icon text-white mb-2"></i>
                            <h5 className="text-uppercase">
                              Do you need Support?
                            </h5>
                            <p className="text-muted">
                              You're OK. We're NOT. Will be back
                              soon!!!
                              <a
                                href="mailto:#"
                                className="text-muted font-weight-bold"
                              >
                                {" "}
                                team@vitorscape.com
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMaintenance;
